import { BenefitCard } from './benefit-card';
import DeliveryIcon from '../../images/delivery_icon.svg';
import DollarIcon from '../../images/dollar_icon.svg';
import RocketIcon from '../../images/rocket_icon.svg';
import UnifyIcon from '../../images/unify_icon.svg';
import { messages } from '../messages';
import style from '../style.module.less';

export const BenefitsGrid = () => {
  return (
    <div className={style['benefits-grid']}>
      <BenefitCard description={messages.deliverFasterDescription} iconSrc={DeliveryIcon} title={messages.deliverFasterTitle} />
      <BenefitCard description={messages.competitiveRatesDescription} iconSrc={DollarIcon} title={messages.competitiveRatesTitle} />
      <BenefitCard description={messages.scaleWithoutLimitsDescription} iconSrc={RocketIcon} title={messages.scaleWithoutLimitsTitle} />
      <BenefitCard description={messages.unifyShippingDescription} iconSrc={UnifyIcon} title={messages.unifyShippingTitle} />
    </div>
  );
};
